import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KPI } from "@/components/Primitives";

export default function MSPBI() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/msp-bi").then(r => setD(r.data)); }, []);
  if (!d) return <div className="text-zinc-500 text-sm">Loading…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">MSP Business Intelligence</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Profitability & Productivity</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Revenue MTD" value={`₱${d.revenue_mtd_php.toLocaleString()}`} tone="good" testid="bi-rev"/>
        <KPI label="Labor Cost MTD" value={`₱${d.labor_cost_mtd_php.toLocaleString()}`} testid="bi-labor"/>
        <KPI label="Avg Ticket Cost" value={`₱${d.ticket_cost_avg_php}`} testid="bi-tkt"/>
        <KPI label="Contract Profit" value={`${d.contract_profitability_pct}%`} tone="good" testid="bi-profit"/>
        <KPI label="Tech Productivity" value={`${d.technician_productivity_pct}%`} tone="good" testid="bi-prod"/>
        <KPI label="Escalation Rate" value={`${d.escalation_rate_pct}%`} tone="warn" testid="bi-esc"/>
        <KPI label="Renewal Probability" value={`${d.renewal_probability_pct}%`} tone="good" testid="bi-renew"/>
        <KPI label="Growth QoQ" value={`+${d.growth_qoq_pct}%`} tone="good" testid="bi-growth"/>
        <KPI label="Avg Resolution" value={`${d.avg_resolution_hours}h`} testid="bi-res"/>
        <KPI label="Close Rate" value={`${d.ticket_close_rate_pct}%`} tone="good" testid="bi-close"/>
        <KPI label="Customer Risk" value={d.customer_risk_avg} tone="warn" testid="bi-risk"/>
      </div>
    </div>
  );
}
